import React from 'react';
import {Outlet} from 'react-router-dom';

const Ingestion: React.FC = () => {
  return <Outlet />;
};
export default Ingestion;
